module.exports = __webpack_public_path__ + "img/65-r.f279e29d.png";